'use client';

import { useEffect } from 'react';
import { TwoFactorAuthenticationState } from '@bts-web/data-layer/server';
import { ResetTwoFaModal, SetupTwoFaModal } from '../components';
import { useModalDrawerContext } from '../components/ModalDrawerContext/ModalDrawerContext';
import { getTwoFATranslations } from '../components/composableModals/twoFaModals/ResetTwoFaModal/utils/get2faTranslations';
import { useClientTranslation } from '@bts-web/utils-lokalise';

export const User2faSetupObserver = ({
  twoFactorAuthentication,
}: {
  twoFactorAuthentication: TwoFactorAuthenticationState;
}) => {
  const { showModal } = useModalDrawerContext();

  const { t } = useClientTranslation();

  useEffect(() => {
    const translations = getTwoFATranslations(t);

    if (twoFactorAuthentication === 'RESET_IN_PROGRESS') {
      showModal(ResetTwoFaModal, {
        disableOverlayClose: true,
        translations,
      });

      return;
    }

    if (twoFactorAuthentication === 'SETUP_IN_PROGRESS') {
      showModal(SetupTwoFaModal, { disableOverlayClose: true, translations });
    }
  }, [twoFactorAuthentication]);

  return null;
};
